export function byteFormat(bytes) {
    if (bytes === 0) return '0B';
    var k = 1000, // or 1024
        sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));

    return (bytes / Math.pow(k, i)).toPrecision(3) + sizes[i];
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
    const event = document.createEvent('HTMLEvents');
    event.initEvent('resize', true, true);
    event.eventType = 'message';
    window.dispatchEvent(event);
}

export function handleScrollHeader(callback) {
    let timer = 0;

    let beforeScrollTop = window.pageYOffset;
    callback =
        callback ||
        function () {
            //
        };
    window.addEventListener(
        'scroll',
        () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                let direction = 'up';
                const afterScrollTop = window.pageYOffset;
                const delta = afterScrollTop - beforeScrollTop;
                if (delta === 0) {
                    return false;
                }
                direction = delta > 0 ? 'down' : 'up';
                callback(direction);
                beforeScrollTop = afterScrollTop;
            }, 50);
        },
        false
    );
}

export function isIE() {
    const bw = window.navigator.userAgent;
    const compare = (s) => bw.indexOf(s) >= 0;
    const ie11 = (() => 'ActiveXObject' in window)();
    return compare('MSIE') || ie11;
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
    if (id === '') {
        return;
    }
    setTimeout(() => {
        document.body.removeChild(document.getElementById(id));
    }, timeout);
}

export const getPrimaryType = (params) => Object.prototype.toString.call(params).slice(8, -1);

export const requireAll = (context) => context.keys().map(context);

export const transfer2ids = (array) => {
    if (getPrimaryType(array) !== 'Array') return array;

    return array.reduce(
        (acc, item) => {
            return {
                byId: {
                    ...acc.byId,
                    [item.id]: item
                },
                allIds: [...new Set([...acc.allIds, item.id])]
            };
        },
        { byId: {}, allIds: [] }
    );
};
export function getParamsFromUrl(url) {
    const params = new URLSearchParams(url.split('?')[1]);
    const result = {};
    for (const [key, value] of params) {
        result[key] = value;
    }
    return result;
};
export function aesEncrypt(data) {
    return data;
    if(!data){
        return ''
    }
    let key = CryptoJS.enc.Utf8.parse('nBdUx85vPHkDKg284d7NkjFaNcKWBukz');      
    let iv  = CryptoJS.enc.Utf8.parse('c558Gq0YQK2QUlMc');                     
    
    let cipher = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return cipher.toString();
}
export function aesDecode(str) {//解密
    return str;
    let key = CryptoJS.enc.Utf8.parse('nBdUx85vPHkDKg284d7NkjFaNcKWBukz');      
    let iv  = CryptoJS.enc.Utf8.parse('c558Gq0YQK2QUlMc');                     
    
    let ciphertext = CryptoJS.enc.Base64.parse(str);          
    let encryptedCP = CryptoJS.lib.CipherParams.create({
        ciphertext: ciphertext,
        formatter: CryptoJS.format.OpenSSL                                   
    });
    let decryptedWA = CryptoJS.AES.decrypt(encryptedCP, key, { iv: iv});
    let decryptedUtf8 = decryptedWA.toString(CryptoJS.enc.Utf8);      
    return decryptedUtf8
}
